<template>
  <div class="footerPage">
    <!-- 图片 -->
    <div class="footerImg">
      <div class="boxIn">
        <h3>提升信用，就上汇信云课堂</h3>
        <p>传递政府声音，分享专家解读……<br /> 提升企业信用水平，助力企业快速发展！</p>
      </div>

    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="flex boxIn">
        <div class="footerLogo">
          <div class="logo">
            <img src="/static/images/new/logo.png" />
          </div>
          <div class="companyInfo">
            <a href="#" target="_blank">汇信科技有限公司版权所有</a> <br />
            <a href="http://www.beian.miit.gov.cn" target="_blank">浙ICP备20025217号-1</a> <br />
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502002208" target="_blank">浙公网安备：33010502002203号</a>
          </div>
        </div>
        <div class="con clearfix">

          <!-- <div class="footer_bot">
            <a href="http://www.beian.miit.gov.cn" target="_blank" style="margin-right: 20px">浙ICP备：浙B2-20070198-13 </a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502002208" target="_blank">
              浙公网安备:33010502002208号</a>
          </div> -->
          <div class="footer_ul" v-for="item in footer">
            <p>{{item.name}}</p>
            <div class="footer_li" v-for="child in item.item">
              <a :href="child.url" target="_blank">{{child.name}}</a>
            </div>
          </div>

          <div class="wx clearfix">
            <div class="wx_con">
              <img src="/static/images/ll.png">
              <p>扫码关注联连</p>
            </div>
            <div class="wx_con" style="margin-right: 40px">
              <img src="/static/images/hx.png">
              <p>扫码关注汇信</p>
            </div>
          </div>

        </div>
      </div>

    </div>
    <!-- phone -->
    <div class="phoneBox">
      <p>咨询电话：400-888-4636</p>
      <!--<div class="phoneNum">400-888-4636</div>-->
      <p>异议申诉电话：0571-88350735</p>
      <div class="botBox"></div>
      <p class="time">
        服务时间：周一至周五8:30 - 17:30 周六9:00 - 17:00
      </p>
    </div>

  </div>

</template>

<script>
  export default {
    name: "index_footer",
    data() {
      return {
        footer: [
          {
            name: '产品与服务',
            item: [
              {name: '可信认证', url: 'http://www.icinfo.cn/page/client/product/trustedVerifying/identity?active=pro'},
              {name: '企业服务', url: 'http://www.icinfo.cn/page/client/product/creditService/creditData?active=pro'},
              {name: '联连平台', url: 'http://www.linksgood.com/'},
            ]
          },
          {
            name: '关于我们',
            item: [
              {name: '公司简介', url: 'http://www.icinfo.cn/page/client/about?active=about#introduce'},
              // {name: '合作伙伴', url: 'http://www.icinfo.cn/page/client/about?active=about#cooperative-partner'},
              {name: '数字政府服务', url: ''},
              {name: '科技金融服务', url: ''},
            ]
          },
          // {
          //   name: '联系方式',
          //   item: [
          //     {name: '客服', url: 'http://www.icinfo.cn/page/client/about?active=about#contact'},
          //     {name: '业务', url: 'http://www.icinfo.cn/page/client/about?active=about#contact'},
          //     {name: '商务', url: 'http://www.icinfo.cn/page/client/about?active=about#contact'},
          //     {name: '媒体', url: 'http://www.icinfo.cn/page/client/about?active=about#contact'},
          //   ]
          // },
          {
            name: '友情链接',
            item: [
              {name: '浙江省法人数字证书服务平台', url: 'http://zsfwpt.icinfo.cn/index'},
              {name: '浙江省法人数字证书（宁波）平台', url: 'http://huixin.icinfo.cn/common/digitalCert_nb/digitalCert.jsp'}
            ]
          },

        ]
      }
    },
  }
</script>

<style scoped lang="less" type="text/less">
  .boxIn{
    width: 1180px;
    margin: 0 auto;
  }
  .flex{
    display: flex;
  }
  .footerPage{
    position: relative;
    .footerImg{
      background-image: url("/static/images/new/footerBg.png");
      background-size:100% 100%;
      background-repeat: no-repeat;
      height:300px ;

      h3{
        padding-top: 122px;
        font-size: 24px;
        font-weight: 800;
        color: #FFFFFF;
        margin-bottom: 38px;
      }
      p{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
      }

    }

    .phoneBox{
      position: absolute;
      top: 93px;
      right: 370px;
      width: 460px;
      height: 254px;
      background: #4698FF;
      border-radius: 12px;
      padding:48px 49px ;
      box-sizing: border-box;
      p:first-child,p:nth-child(2){
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 16px;
      }
      .phoneNum{
        font-size: 32px;
        font-weight: bold;
        color: #FFFFFF;
      }
      .botBox{
        height: 40px;
        border-bottom: 1px solid  rgba(254, 254, 254, 0.6);
        margin-bottom: 28px;
      }
      .time{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
  // 底部
  .footer {
    height: 340px;
    width: 100%;
    background: #06172a;
    background-image: url(/static/images/new/footerBot.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 118px;
    box-sizing: border-box;
    .footerLogo{
      .logo{
        height: 52px;
        width: 150px;
        margin-bottom: 36px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .companyInfo{
        width: 321px;
        a{
           font-size: 12px;
           font-weight: 400;
           color: rgba(255, 255, 255, 0.6);
           line-height: 22px;
        }
      }
    }

    .con {
      // width: 1210px;
      width: 1180px;
      margin: 0 auto;
      height: 200px;

      .footer_ul {
        float: left;
        margin-right: 72px;

        p {
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          line-height: 18px;
          margin-bottom: 21px;
        }

        .footer_li {
          font-size: 14px;
          font-weight: 400;
          margin-bottom: 16px;
          a {
            color: #FFFFFF;
          }
        }
      }

      .footer_ul:last-child {
        width: 220px;
      }
    }

    .wx {
      position: absolute;
      right: 0;
      top: 0;
      img{
        width: 116px;
        height: 114px;
      }
    }
    .wx_con{
      float: right;
      p{
        text-align: center;
        height: 50px;
        line-height: 50px;
        color: #c0c7d6;
        font-size: 16px;
      }

    }
    .footer_bot{
      position: absolute;
      left: 0;
      bottom: 0;
      a{
        color: #56616c;
        font-size: 14px;
      }
      a:last-child{
        padding-left: 23px;
        background: url("/static/images/ga.png") no-repeat left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index_footer.vue